import { css } from 'styled-components'
import styled, { theme } from '../../../../theme'

const IconBackground = styled.div<IIconBackground>`
  width: ${({ size }) => (size ? 32 * size : 32)}px;
  height: ${({ size }) => (size ? 32 * size : 32)}px;
  min-height: ${({ size }) => (size ? 32 * size : 32)}px;
  min-width: ${({ size }) => (size ? 32 * size : 32)}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.color};
  ${props =>
    props.color === theme.colors.palette.slateGrey
      ? css`
          filter: grayscale(100%);
        `
      : ''};
  margin-right: ${({ size }) => (size ? 20 * size : 20)}px;
`

export default IconBackground

export interface IIconBackground {
  color?: string
  size?: number
}
